import { FormSubmissionSubmittedBy } from "../../../api/web-api-client";
import { IState } from "../shared/interfaces";


export const emptyValidationMessages = { 'required': [], 'regex': [] };

export const initialState: IState = {
    id: '',
    locationId: null,
    assignmentId: '',
    submissionId: '',
    submittedBy: FormSubmissionSubmittedBy.Patient,
    legacy: false,
    loading: true,
    submitting: false,
    data: null,
    mutate: null,
    error: null,
    redirect: false,
    preview: false,
    practiceView: false,
    pdf: null,
    uri: '',
    images: [],
    pagePlacesHolders: null,
    validationMessages: emptyValidationMessages as Record<string, string[]>,
    openConfirmCancelDialogue: false,
    readOnly: false,
    showSkeleton: true,
    hideActionBar: false,
    formViewActionBarString: '',
    pmsSystemVm: {},
    pmsSystemLoaded: false,
    loadPmsSystem: false,
    loadPayerList: false,
    templateType: null
}

export enum ActionKind {
    SET_INIT = 'setInit',
    SET_ID = 'setId',
    SET_LOCATION_ID = 'setLocationId',
    SET_ASSIGNMENTID = 'setAssignmentId',
    SET_SUBMISSIONID = 'setSubmissionId',
    SET_SUBMITTEDBY = 'setSubmittedBy',
    SET_LEGACY = 'setLegacy',
    SET_LOADING = 'setLoading',
    SET_REDIRECT = 'setRedirect',
    SET_DATA = 'setData',
    SET_COMPONENTS = 'setComponents',
    SET_LAYOUT = 'setLayout',
    SET_TEMP_LAYOUT = 'setTempLayout',
    SET_RULES = 'setRules',
    SET_ERROR = 'setError',
    SET_PDF = 'setPdf',
    SET_URI = 'setUri',
    SET_IMAGES = 'setImages',
    SET_PAGE_PLACEHOLDERS = 'setPagePalaceholders',
    SET_DRAGGING = 'setErrors',
    SET_VALIDATION_MESSAGES = 'setValidationMessages',
    SET_OPEN_CONFIRM_CANCEL_DIALOGUE = 'setOpenConfirmCancelDialogue',
    SET_SUBMITTING = 'setSubmitting',
    SET_HAS_PRACTICE_SIGNATURE = 'setHasPracticeSignature',
    SET_PMSSYSTEM = 'setPmsSystem',
    SET_PMSSYSTEMLOADED = 'pmsSystemLoaded',
    SET_LOADPMSSYSTEM = 'loadPmsSystem',
    SET_LOADPAYERLIST = 'loadPayerList',
    SET_PAYERLIST = 'setPayerList',
    SET_TEMPLATE_TYPE = 'setTemplateType'
}

export const reducer = (state: IState, action) => {
    switch (action.type) {
        case ActionKind.SET_INIT:
            return { ...state, ...action.payload }
        case ActionKind.SET_ID:
            return { ...state, id: action.payload }
        case ActionKind.SET_SUBMISSIONID:
            return { ...state, submissionId: action.payload }
        case ActionKind.SET_LOCATION_ID:
            return { ...state, locationId: action.payload }
        case ActionKind.SET_ASSIGNMENTID:
            return { ...state, assignmentId: action.payload }
        case ActionKind.SET_SUBMITTEDBY:
            return { ...state, submittedBy: action.payload }
        case ActionKind.SET_LEGACY:
            return { ...state, legacy: action.payload }
        case ActionKind.SET_LOADING:
            return { ...state, loading: action.payload }
        case ActionKind.SET_SUBMITTING:
            return { ...state, submitting: action.payload }
        case ActionKind.SET_REDIRECT:
            return { ...state, redirect: action.payload }
        case ActionKind.SET_DATA:
            return { ...state, data: action.payload }
        case ActionKind.SET_COMPONENTS:
            return { ...state, data: { ...state.data, json: { ...state.data.json, components: action.payload } } }
        case ActionKind.SET_LAYOUT:
            return { ...state, data: { ...state.data, json: { ...state.data.json, layout: action.payload } } }
        case ActionKind.SET_TEMP_LAYOUT:
            return { ...state, tempLayout: action.payload }
        case ActionKind.SET_RULES:
            return { ...state, rules: action.payload }
        case ActionKind.SET_PDF:
            return { ...state, pdf: action.payload }
        case ActionKind.SET_URI:
            return { ...state, uri: action.payload }
        case ActionKind.SET_IMAGES:
            return { ...state, images: action.payload }
        case ActionKind.SET_PAGE_PLACEHOLDERS:
            return { ...state, pagePlacesHolders: action.payload }
        case ActionKind.SET_ERROR:
            return { ...state, error: action.payload }
        case ActionKind.SET_VALIDATION_MESSAGES:
            return { ...state, validationMessages: action.payload }
        case ActionKind.SET_OPEN_CONFIRM_CANCEL_DIALOGUE:
            return { ...state, openConfirmCancelDialogue: action.payload }
        case ActionKind.SET_PMSSYSTEM:
            return { ...state, pmsSystemVm: action.payload }
        case ActionKind.SET_LOADPMSSYSTEM:
            return { ...state, loadPmsSystem: action.payload }
        case ActionKind.SET_PMSSYSTEMLOADED:
            return { ...state, pmsSystemLoaded: action.payload }
        case ActionKind.SET_LOADPAYERLIST:
            return { ...state, loadPayerList: action.payload }
        case ActionKind.SET_TEMPLATE_TYPE:
            return { ...state, templateType: action.payload }
        default:
            return state;
    }
}